import gql from 'graphql-tag';

export const BPF_CHANGELOG_VIEW_MODEL_FRAGMENT = gql`
  fragment BpfChangelogViewModelFields on BpfChangelogViewModel {
    id
    accountId
    changeType
    changes
    createdDateTime
    parentId
    modifiedBy {
      id
      email
      firstName
      lastName
      fullName
    }
  }
`;
